import { render } from "./AposCellType.vue?vue&type=template&id=f19d1fcc"
import script from "./AposCellType.vue?vue&type=script&lang=js"
export * from "./AposCellType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposCellType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f19d1fcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f19d1fcc', __exports__)) {
    api.reload('f19d1fcc', __exports__)
  }
  
  module.hot.accept("./AposCellType.vue?vue&type=template&id=f19d1fcc", () => {
    api.rerender('f19d1fcc', render)
  })

}


export default __exports__